/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import Spinner from 'components/spinner/spinner';
import GeneralError from 'components/general-error/general-error';
import { IncomeStatementService } from 'frilans-finans';

export class IncomeStatements extends React.Component {

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      selectValue: '0',
      fetching: true,
      fetched: false,
      fetchError: false,
      statements: [],
      pendingRequest: null
    };

    this.setYear = this.setYear.bind(this);
    this.downloadYear = this.downloadYear.bind(this);
  }

  componentDidMount () {
    this.fetchStatements();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  fetchStatements () {
    this.setState({
      fetching: true
    }, () => {
      let pendingRequest = IncomeStatementService.getIncomeStatements(this.context.user.id);
      pendingRequest.promise
        .then(this.handleResponse.bind(this))
        .catch(this.handleError.bind(this));

      this.setState({
        pendingRequest: pendingRequest
      });
    });
  }

  handleResponse (response) {
    let statements = response;

    if (statements.length === 0) {
      statements.push({
        disabled: true,
        name: proxyCounterpart('NO_STATEMENTS'),
        value: '0'
      });
    } else {
      statements.unshift({
        disabled: true,
        name: proxyCounterpart('CHOOSE_INCOME_YEAR'),
        value: '0'
      });
    }

    this.setState({
      fetching: false,
      fetched: true,
      fetchError: false,
      statements: statements
    });
  }

  handleError (error) {
    if (error.response !== undefined) {
      this.setState({
        fetching: false,
        fetched: true,
        fetchError: true
      });
    }
  }

  setYear (e) {
    this.setState({
      selectValue: e.target.value
    });
  }

  downloadYear () {
    if (this.state.selectValue !== '0') {
      let statement = null;
      for (let s of this.state.statements) {
        if (s.id === this.state.selectValue) {
          statement = s;
        }
      }

      if (statement) {
        window.open(statement.url);
      }
    }
  }

  renderOption (statement, i) {
    return (<option disabled={statement.disabled} value={statement.value} key={i}>{statement.name}</option>);
  }

  renderDropDown () {
    let options = {};

    if (this.state.statements.length <= 1) {
      options['disabled'] = 'disabled';
    }

    return (
      <div className='select-btn-wrapper'>
        <div className='styled-select'>
          <select value={this.state.selectValue} onChange={this.setYear} {...options}>
            {this.state.statements.map(this.renderOption)}
          </select>
        </div>
        <button className='btn download-btn' onClick={this.downloadYear}><Translate content='DOWNLOAD'/></button>
      </div>
    );
  }

  renderContent () {
    if (this.state.fetchError) {
      return (<GeneralError />);
    }
    if (this.state.fetching) {
      return (
        <div className='loader-wrapper'>
          <Spinner />
        </div>
      );
    }

    if (this.state.fetched) {
      return this.renderDropDown();
    }
  }

  render () {
    return (
      <div className='contract-picker'>
        <h2><Translate content='YOUR_CONTROL_STATEMENT'/></h2>
        <p><Translate content='YOUR_CONTROL_STATEMENT_TEXT'/></p>

        {this.renderContent()}

      </div>
    );
  }
}
export default IncomeStatements;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/income-statements/income-statements.js
 **/